module.exports = __webpack_public_path__ + "static/img/icon_not_data.59d6a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_not_data.png
// module id = Q97k
// module chunks = 33